import { IOmniaSession } from "../../omnia"

const tabs = [
    {
        id: "crop",
        text: "Crop"
    },
    {
        id: "info",
        text: "Info"
    },
    {
        id: "management",
        text: "Management"
    }
] as const

export type TabKey = typeof tabs[number]["id"]

export function getAvailableTabs(session: IOmniaSession) {

    const cfg = omnia.crops.getCropManagementConfig(session)

    return tabs
        .map(t => {

            if (t.id !== "management") {
                return t
            }

            if (!cfg?.enabled) {
                return undefined
            }

            return {
                ...t,
                text: cfg.shortTitle
            }

        })
        .filter(t => !!t)

}
